import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { WallsModels } from '../../../models/walls.model';
import { OrgWallEntry } from './org-walls.models';

export const OrgWallsActions = createActionGroup({
  source: 'Org Walls',
  events: {
    'Load Org Walls': props<{ query?: WallsModels.GetOrgWallsQuery }>(),
    'Get Next Page': emptyProps(),
    'Load Org Walls Request': props<{ query: WallsModels.GetOrgWallsQuery }>(),
    'Load Org Walls Success': props<{
      walls: OrgWallEntry[];
      query: WallsModels.GetOrgWallsQuery;
    }>(),
    'Load Org Walls Fail': props<{ error: string }>(),
    'Reset Org Walls': emptyProps(),
  },
});
